// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/flag.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/flag.proto.
 */
export const file_chalk_server_v1_flag: GenFile = /*@__PURE__*/
  fileDesc("ChpjaGFsay9zZXJ2ZXIvdjEvZmxhZy5wcm90bxIPY2hhbGsuc2VydmVyLnYxIi8KEEZlYXR1cmVGbGFnVmFsdWUSDAoEZmxhZxgBIAEoCRINCgV2YWx1ZRgCIAEoCCIYChZHZXRGZWF0dXJlRmxhZ3NSZXF1ZXN0IksKF0dldEZlYXR1cmVGbGFnc1Jlc3BvbnNlEjAKBWZsYWdzGAEgAygLMiEuY2hhbGsuc2VydmVyLnYxLkZlYXR1cmVGbGFnVmFsdWUiHAoaR2V0VGVhbUZlYXR1cmVGbGFnc1JlcXVlc3QiTwobR2V0VGVhbUZlYXR1cmVGbGFnc1Jlc3BvbnNlEjAKBWZsYWdzGAEgAygLMiEuY2hhbGsuc2VydmVyLnYxLkZlYXR1cmVGbGFnVmFsdWUiPAoVR2V0RmVhdHVyZUZsYWdSZXF1ZXN0EgwKBGZsYWcYASABKAkSFQoNZGVmYXVsdF92YWx1ZRgCIAEoCCInChZHZXRGZWF0dXJlRmxhZ1Jlc3BvbnNlEg0KBXZhbHVlGAEgASgIIl8KFVNldEZlYXR1cmVGbGFnUmVxdWVzdBIMCgRmbGFnGAEgASgJEg0KBXZhbHVlGAIgASgIEikKBXNjb3BlGAMgASgOMhouY2hhbGsuc2VydmVyLnYxLkZsYWdTY29wZSIYChZTZXRGZWF0dXJlRmxhZ1Jlc3BvbnNlKlgKCUZsYWdTY29wZRIaChZGTEFHX1NDT1BFX1VOU1BFQ0lGSUVEEAASEwoPRkxBR19TQ09QRV9URUFNEAESGgoWRkxBR19TQ09QRV9FTlZJUk9OTUVOVBACMtIDChJGZWF0dXJlRmxhZ1NlcnZpY2USbAoPR2V0RmVhdHVyZUZsYWdzEicuY2hhbGsuc2VydmVyLnYxLkdldEZlYXR1cmVGbGFnc1JlcXVlc3QaKC5jaGFsay5zZXJ2ZXIudjEuR2V0RmVhdHVyZUZsYWdzUmVzcG9uc2UiBpACAYB9AhJ4ChNHZXRUZWFtRmVhdHVyZUZsYWdzEisuY2hhbGsuc2VydmVyLnYxLkdldFRlYW1GZWF0dXJlRmxhZ3NSZXF1ZXN0GiwuY2hhbGsuc2VydmVyLnYxLkdldFRlYW1GZWF0dXJlRmxhZ3NSZXNwb25zZSIGkAIBgH0CEmkKDkdldEZlYXR1cmVGbGFnEiYuY2hhbGsuc2VydmVyLnYxLkdldEZlYXR1cmVGbGFnUmVxdWVzdBonLmNoYWxrLnNlcnZlci52MS5HZXRGZWF0dXJlRmxhZ1Jlc3BvbnNlIgaQAgGAfQISaQoOU2V0RmVhdHVyZUZsYWcSJi5jaGFsay5zZXJ2ZXIudjEuU2V0RmVhdHVyZUZsYWdSZXF1ZXN0GicuY2hhbGsuc2VydmVyLnYxLlNldEZlYXR1cmVGbGFnUmVzcG9uc2UiBpACAoB9G0IUWhJzZXJ2ZXIvdjE7c2VydmVydjFiBnByb3RvMw", [file_chalk_auth_v1_permissions]);

/**
 * @generated from message chalk.server.v1.FeatureFlagValue
 */
export type FeatureFlagValue = Message<"chalk.server.v1.FeatureFlagValue"> & {
  /**
   * @generated from field: string flag = 1;
   */
  flag: string;

  /**
   * @generated from field: bool value = 2;
   */
  value: boolean;
};

/**
 * Describes the message chalk.server.v1.FeatureFlagValue.
 * Use `create(FeatureFlagValueSchema)` to create a new message.
 */
export const FeatureFlagValueSchema: GenMessage<FeatureFlagValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 0);

/**
 * @generated from message chalk.server.v1.GetFeatureFlagsRequest
 */
export type GetFeatureFlagsRequest = Message<"chalk.server.v1.GetFeatureFlagsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetFeatureFlagsRequest.
 * Use `create(GetFeatureFlagsRequestSchema)` to create a new message.
 */
export const GetFeatureFlagsRequestSchema: GenMessage<GetFeatureFlagsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 1);

/**
 * @generated from message chalk.server.v1.GetFeatureFlagsResponse
 */
export type GetFeatureFlagsResponse = Message<"chalk.server.v1.GetFeatureFlagsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.FeatureFlagValue flags = 1;
   */
  flags: FeatureFlagValue[];
};

/**
 * Describes the message chalk.server.v1.GetFeatureFlagsResponse.
 * Use `create(GetFeatureFlagsResponseSchema)` to create a new message.
 */
export const GetFeatureFlagsResponseSchema: GenMessage<GetFeatureFlagsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 2);

/**
 * @generated from message chalk.server.v1.GetTeamFeatureFlagsRequest
 */
export type GetTeamFeatureFlagsRequest = Message<"chalk.server.v1.GetTeamFeatureFlagsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetTeamFeatureFlagsRequest.
 * Use `create(GetTeamFeatureFlagsRequestSchema)` to create a new message.
 */
export const GetTeamFeatureFlagsRequestSchema: GenMessage<GetTeamFeatureFlagsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 3);

/**
 * @generated from message chalk.server.v1.GetTeamFeatureFlagsResponse
 */
export type GetTeamFeatureFlagsResponse = Message<"chalk.server.v1.GetTeamFeatureFlagsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.FeatureFlagValue flags = 1;
   */
  flags: FeatureFlagValue[];
};

/**
 * Describes the message chalk.server.v1.GetTeamFeatureFlagsResponse.
 * Use `create(GetTeamFeatureFlagsResponseSchema)` to create a new message.
 */
export const GetTeamFeatureFlagsResponseSchema: GenMessage<GetTeamFeatureFlagsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 4);

/**
 * @generated from message chalk.server.v1.GetFeatureFlagRequest
 */
export type GetFeatureFlagRequest = Message<"chalk.server.v1.GetFeatureFlagRequest"> & {
  /**
   * @generated from field: string flag = 1;
   */
  flag: string;

  /**
   * @generated from field: bool default_value = 2;
   */
  defaultValue: boolean;
};

/**
 * Describes the message chalk.server.v1.GetFeatureFlagRequest.
 * Use `create(GetFeatureFlagRequestSchema)` to create a new message.
 */
export const GetFeatureFlagRequestSchema: GenMessage<GetFeatureFlagRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 5);

/**
 * @generated from message chalk.server.v1.GetFeatureFlagResponse
 */
export type GetFeatureFlagResponse = Message<"chalk.server.v1.GetFeatureFlagResponse"> & {
  /**
   * @generated from field: bool value = 1;
   */
  value: boolean;
};

/**
 * Describes the message chalk.server.v1.GetFeatureFlagResponse.
 * Use `create(GetFeatureFlagResponseSchema)` to create a new message.
 */
export const GetFeatureFlagResponseSchema: GenMessage<GetFeatureFlagResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 6);

/**
 * @generated from message chalk.server.v1.SetFeatureFlagRequest
 */
export type SetFeatureFlagRequest = Message<"chalk.server.v1.SetFeatureFlagRequest"> & {
  /**
   * @generated from field: string flag = 1;
   */
  flag: string;

  /**
   * @generated from field: bool value = 2;
   */
  value: boolean;

  /**
   * @generated from field: chalk.server.v1.FlagScope scope = 3;
   */
  scope: FlagScope;
};

/**
 * Describes the message chalk.server.v1.SetFeatureFlagRequest.
 * Use `create(SetFeatureFlagRequestSchema)` to create a new message.
 */
export const SetFeatureFlagRequestSchema: GenMessage<SetFeatureFlagRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 7);

/**
 * @generated from message chalk.server.v1.SetFeatureFlagResponse
 */
export type SetFeatureFlagResponse = Message<"chalk.server.v1.SetFeatureFlagResponse"> & {
};

/**
 * Describes the message chalk.server.v1.SetFeatureFlagResponse.
 * Use `create(SetFeatureFlagResponseSchema)` to create a new message.
 */
export const SetFeatureFlagResponseSchema: GenMessage<SetFeatureFlagResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_flag, 8);

/**
 * @generated from enum chalk.server.v1.FlagScope
 */
export enum FlagScope {
  /**
   * @generated from enum value: FLAG_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLAG_SCOPE_TEAM = 1;
   */
  TEAM = 1,

  /**
   * @generated from enum value: FLAG_SCOPE_ENVIRONMENT = 2;
   */
  ENVIRONMENT = 2,
}

/**
 * Describes the enum chalk.server.v1.FlagScope.
 */
export const FlagScopeSchema: GenEnum<FlagScope> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_flag, 0);

/**
 * @generated from service chalk.server.v1.FeatureFlagService
 */
export const FeatureFlagService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.FeatureFlagService.GetFeatureFlags
   */
  getFeatureFlags: {
    methodKind: "unary";
    input: typeof GetFeatureFlagsRequestSchema;
    output: typeof GetFeatureFlagsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.FeatureFlagService.GetTeamFeatureFlags
   */
  getTeamFeatureFlags: {
    methodKind: "unary";
    input: typeof GetTeamFeatureFlagsRequestSchema;
    output: typeof GetTeamFeatureFlagsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.FeatureFlagService.GetFeatureFlag
   */
  getFeatureFlag: {
    methodKind: "unary";
    input: typeof GetFeatureFlagRequestSchema;
    output: typeof GetFeatureFlagResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.FeatureFlagService.SetFeatureFlag
   */
  setFeatureFlag: {
    methodKind: "unary";
    input: typeof SetFeatureFlagRequestSchema;
    output: typeof SetFeatureFlagResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_flag, 0);

